{
  "name": "Papiergaist, Designsprache W82",
  "stand": "2026-10-17",
  "entscheid": "D-408: Grundfassung R11 (lebhaft, Palette Nachtblau); Palette Tintenblau (R10) als Einstellung; ruhige Fassung R13 mit beiden Paletten; Präsenz des Geists in drei Stufen, Vorgabe Überall",
  "normativ": "Diese Datei ist die Quelle der Werte; die Tabellen in DESIGN-W82.md sind daraus erzeugt.",
  "quellen": {
    "nachtblau": "r11-geist-nacht.html (.bildschirm und .tag .bildschirm); ruhige Rollen (knopfRand, flaecheLeise, ruheTiefe, schalterZwei, funkeText) aus r13-schlicht.html (.pal-r9)",
    "tintenblau": "r10-geist-tinte.html (.bildschirm und .tag .bildschirm), in r13-schlicht.html wortgleich übernommen; ruhige Rollen aus r13-schlicht.html",
    "schrift_und_masse": "r11-geist-nacht.html (lebhaft), r13-schlicht.html (ruhig)"
  },
  "einstellungen": {
    "fassung": {
      "werte": [
        "lebhaft",
        "ruhig"
      ],
      "vorgabe": "lebhaft",
      "schaltet": "Licht und Bewegung; ob auch der Aufbau wechselt, ist offen (abweichungen.md F1)"
    },
    "palette": {
      "werte": [
        "nachtblau",
        "tintenblau"
      ],
      "vorgabe": "nachtblau",
      "schaltet": "nur Farbvariablen"
    },
    "praesenz": {
      "werte": [
        "ueberall",
        "erklaeren",
        "keine"
      ],
      "namen": [
        "Überall",
        "Nur bei Erklärungen",
        "Keine Erklärungen"
      ],
      "vorgabe": "ueberall",
      "hinweisBeimErstenStart": "Hinweise lassen sich reduzieren (D-408); Ort und Wortlaut offen"
    },
    "erscheinung": {
      "werte": [
        "hell",
        "dunkel"
      ],
      "vorgabe": null,
      "hinweis": "Die Seiten zeigen beide über einen Umschalter; im Bestand folgt die App dem System (darstellung.ts, PGTokens)"
    }
  },
  "farbRollen": {
    "grundOben": {
      "gruppe": "Hintergrund",
      "verwendung": "Grund, oberes Ende des Verlaufs (180 Grad)"
    },
    "grundMitte": {
      "gruppe": "Hintergrund",
      "verwendung": "Grund, Mitte des Verlaufs"
    },
    "grundUnten": {
      "gruppe": "Hintergrund",
      "verwendung": "Grund, unteres Ende des Verlaufs"
    },
    "dunst": {
      "gruppe": "Hintergrund",
      "verwendung": "Dunst unten links (nur lebhaft, radial 470 x 380 px)"
    },
    "glas": {
      "gruppe": "Glas",
      "verwendung": "Glasfläche: Module, Karten, Leisten, Akten"
    },
    "glasDicht": {
      "gruppe": "Glas",
      "verwendung": "Dichtes Glas: Blasen, Hinweis, Ersatz ohne Transparenz"
    },
    "glanz": {
      "gruppe": "Glas",
      "verwendung": "Glanz oben links im Glas (nur lebhaft)"
    },
    "kanteA": {
      "gruppe": "Glas",
      "verwendung": "Lichtkante, Anfang (150 Grad, nur lebhaft)"
    },
    "kanteB": {
      "gruppe": "Glas",
      "verwendung": "Lichtkante bei 32 %"
    },
    "kanteC": {
      "gruppe": "Glas",
      "verwendung": "Lichtkante bei 62 %"
    },
    "kanteD": {
      "gruppe": "Glas",
      "verwendung": "Lichtkante, Ende"
    },
    "leiste": {
      "gruppe": "Glas",
      "verwendung": "Tab-Leiste (Glas-Pille)"
    },
    "leisteAktiv": {
      "gruppe": "Glas",
      "verwendung": "Licht unter dem aktiven Reiter und der gewählten Sortierung"
    },
    "linseGrund": {
      "gruppe": "Glas",
      "verwendung": "Glaslinse (Symbolkreis, Kürzel), Grund"
    },
    "linseLicht": {
      "gruppe": "Glas",
      "verwendung": "Glaslinse, Lichtpunkt oben links"
    },
    "linseRand": {
      "gruppe": "Glas",
      "verwendung": "Glaslinse, Rand"
    },
    "flaecheLeise": {
      "gruppe": "Glas",
      "verwendung": "Leise Fläche: Knopf „Anders“, „Zeig es mir“ (ruhig), Fakten, Schalterzeile, neutraler Symbolkreis (ruhig)"
    },
    "linie": {
      "gruppe": "Linien",
      "verwendung": "Linie: Trenner, Raster, feiner Rand der ruhigen Fläche"
    },
    "linieStark": {
      "gruppe": "Linien",
      "verwendung": "Starke Linie: Rand von „Anders“, Fakt, Status, Schalterbahn (lebhaft)"
    },
    "knopfRand": {
      "gruppe": "Linien",
      "verwendung": "Rand des leisen Knopfs (ruhig)"
    },
    "text": {
      "gruppe": "Text",
      "verwendung": "Text: Titel, Sätze, Beträge, Bald-Zeichen in Nachtblau"
    },
    "text2": {
      "gruppe": "Text",
      "verwendung": "Nebentext: Absender, Achse, Legende, Untertitel, inaktive Reiter"
    },
    "knopfHell": {
      "gruppe": "Text",
      "verwendung": "Heller Knopf: „Zeig sie mir“, „Weiter“, Heute-Pille, Abzeichen"
    },
    "aufKnopfHell": {
      "gruppe": "Text",
      "verwendung": "Schrift auf dem hellen Knopf"
    },
    "ueberfaellig": {
      "gruppe": "Zustand",
      "verwendung": "Überfällig, Grafik: Raute, Säule, Ring, Glimmen (handeln)"
    },
    "ueberfaelligText": {
      "gruppe": "Zustand",
      "verwendung": "Überfällig, Text: „überfällig“, „seit 3 Tagen“, Zahl im Offen-Block"
    },
    "bald": {
      "gruppe": "Zustand",
      "verwendung": "Bald (diese Woche): Punkt, Säule, Text"
    },
    "spaeter": {
      "gruppe": "Zustand",
      "verwendung": "Später: Ring, Umriss der Säule"
    },
    "spaeterFuellung": {
      "gruppe": "Zustand",
      "verwendung": "Später: Füllung der Säule"
    },
    "erledigt": {
      "gruppe": "Zustand",
      "verwendung": "Erledigt, Grafik: Punkt, Säule, Haken, Kreis, Schalter an"
    },
    "erledigtText": {
      "gruppe": "Zustand",
      "verwendung": "Erledigt, Text: „bezahlt“, „Abgelegt“, 0 im Offen-Block"
    },
    "ringOffen": {
      "gruppe": "Zustand",
      "verwendung": "Offener Kreis zum Abhaken (später und Ruhe)"
    },
    "spur": {
      "gruppe": "Zustand",
      "verwendung": "Leere Säule (trägt keine Information)"
    },
    "passt": {
      "gruppe": "Zustand",
      "verwendung": "Knopf „Passt“ (einziger farbige Knopf der Startseite)"
    },
    "aufPasst": {
      "gruppe": "Zustand",
      "verwendung": "Schrift auf „Passt“, Haken im gefüllten Kreis"
    },
    "schalterAus": {
      "gruppe": "Zustand",
      "verwendung": "Schalterbahn aus"
    },
    "schalterZwei": {
      "gruppe": "Zustand",
      "verwendung": "Schalter „Gekündigt“ an (ruhig; „Bezahlt“ nimmt erledigt)"
    },
    "punktRand": {
      "gruppe": "Zustand",
      "verwendung": "Ring um den Zustandspunkt an der Linse"
    },
    "funke": {
      "gruppe": "Akzent",
      "verwendung": "Funke (KI): am Geist, Zeichen „Zu prüfen“, Glyphe im Reiter"
    },
    "funkeText": {
      "gruppe": "Akzent",
      "verwendung": "Funke als Text: „Aus dem Brief“, Unterstrich der Belegstelle"
    },
    "funkeKante": {
      "gruppe": "Akzent",
      "verwendung": "Kante des Funkens auf hellem Grund"
    },
    "markierung": {
      "gruppe": "Akzent",
      "verwendung": "Belegstelle im Brief, Fläche (lebhaft; ruhig: Unterstrich in funkeText)"
    },
    "aufMarkierung": {
      "gruppe": "Akzent",
      "verwendung": "Schrift auf der Markierung"
    },
    "fokus": {
      "gruppe": "Akzent",
      "verwendung": "Fokusrahmen 3 px, Abstand 3 px"
    },
    "auswahl": {
      "gruppe": "Akzent",
      "verwendung": "Textauswahl"
    },
    "geistLeib": {
      "gruppe": "Geist",
      "verwendung": "Körper des Briefgeists"
    },
    "geistAuge": {
      "gruppe": "Geist",
      "verwendung": "Augen und Klappe (wirken als Löcher)"
    },
    "geistLicht": {
      "gruppe": "Geist",
      "verwendung": "Licht des Geists: Schein, Boden, Blasenlicht, Nebel beim Erscheinen"
    },
    "geistLichtNah": {
      "gruppe": "Geist",
      "verwendung": "Deckkraft des nahen Scheins (Schein 7 px)"
    },
    "geistLichtWeit": {
      "gruppe": "Geist",
      "verwendung": "Deckkraft des weiten Scheins (Schein 24 px)"
    },
    "auraInnen": {
      "gruppe": "Geist",
      "verwendung": "Atmende Aura, Mitte"
    },
    "auraAussen": {
      "gruppe": "Geist",
      "verwendung": "Atmende Aura bei 30 %"
    },
    "angeleuchtet": {
      "gruppe": "Geist",
      "verwendung": "Licht auf dem Modul, auf dem er sitzt (lebhaft; wird je Anlass durch die Zustandsfarbe ersetzt)"
    },
    "teilchen": {
      "gruppe": "Geist",
      "verwendung": "Lichtteilchen um den Geist (nur lebhaft, Überall)"
    },
    "schleier": {
      "gruppe": "Geist",
      "verwendung": "Abdunklung beim Scheinwerfer (nur lebhaft, Überall)"
    },
    "lichtkoerperA": {
      "gruppe": "Geist",
      "verwendung": "Lichtkörper hinter dem Glas, kühl (nur lebhaft)"
    },
    "lichtkoerperB": {
      "gruppe": "Geist",
      "verwendung": "Lichtkörper, warm (handeln)"
    },
    "lichtkoerperD": {
      "gruppe": "Geist",
      "verwendung": "Lichtkörper, Dunst"
    },
    "tiefe": {
      "gruppe": "Tiefe",
      "verwendung": "Schatten der Glasflächen (lebhaft)"
    },
    "ruheTiefe": {
      "gruppe": "Tiefe",
      "verwendung": "Schatten der ruhigen Fläche (ruhig)"
    }
  },
  "farben": {
    "nachtblau": {
      "dunkel": {
        "grundOben": "#121D33",
        "grundMitte": "#0B1324",
        "grundUnten": "#070B15",
        "dunst": "rgb(90 115 185 / .10)",
        "glas": "rgb(28 40 66 / .50)",
        "glasDicht": "rgb(30 44 72 / .74)",
        "glanz": "rgb(205 222 255 / .10)",
        "kanteA": "rgb(228 238 255 / .55)",
        "kanteB": "rgb(228 238 255 / .13)",
        "kanteC": "rgb(228 238 255 / .03)",
        "kanteD": "rgb(228 238 255 / .09)",
        "leiste": "rgb(17 26 46 / .62)",
        "leisteAktiv": "rgb(200 215 245 / .13)",
        "linseGrund": "rgb(200 215 245 / .08)",
        "linseLicht": "rgb(230 238 255 / .20)",
        "linseRand": "rgb(220 232 255 / .16)",
        "flaecheLeise": "rgb(200 215 245 / .08)",
        "linie": "rgb(200 215 245 / .11)",
        "linieStark": "rgb(200 215 245 / .22)",
        "knopfRand": "rgb(238 243 251 / .34)",
        "text": "#EEF3FB",
        "text2": "#A6B4C9",
        "knopfHell": "#EEF3FB",
        "aufKnopfHell": "#070B15",
        "ueberfaellig": "#FF6B4A",
        "ueberfaelligText": "#FF8E74",
        "bald": "#EEF3FB",
        "spaeter": "#A6B4C9",
        "spaeterFuellung": "rgb(166 180 201 / .16)",
        "erledigt": "#3DD6A3",
        "erledigtText": "#3DD6A3",
        "ringOffen": "#A6B4C9",
        "spur": "rgb(200 215 245 / .07)",
        "passt": "#3DD6A3",
        "aufPasst": "#070B15",
        "schalterAus": "rgb(200 215 245 / .14)",
        "schalterZwei": "#3DD6A3",
        "punktRand": "#19243A",
        "funke": "#5ECBDD",
        "funkeText": "#5ECBDD",
        "funkeKante": "transparent",
        "markierung": "rgb(94 203 221 / .26)",
        "aufMarkierung": "#EEF3FB",
        "fokus": "#EEF3FB",
        "auswahl": "rgb(120 160 255 / .35)",
        "geistLeib": "#EEF4FB",
        "geistAuge": "#0B1324",
        "geistLicht": "#DCE8FF",
        "geistLichtNah": ".85",
        "geistLichtWeit": ".42",
        "auraInnen": "rgb(220 232 255 / .40)",
        "auraAussen": "rgb(220 232 255 / .12)",
        "angeleuchtet": "#DCE8FF",
        "teilchen": "rgb(220 232 255 / .9)",
        "schleier": "rgb(5 8 16 / .66)",
        "lichtkoerperA": "rgb(220 232 255 / .10)",
        "lichtkoerperB": "rgb(255 107 74 / .06)",
        "lichtkoerperD": "rgb(90 115 185 / .14)",
        "tiefe": "0 24px 44px -26px rgb(0 0 0 / .92), 0 2px 8px -3px rgb(0 0 0 / .5)",
        "ruheTiefe": "0 18px 34px -26px rgb(0 0 0 / .9)"
      },
      "hell": {
        "grundOben": "#F7F9FD",
        "grundMitte": "#EEF2F8",
        "grundUnten": "#E2E8F1",
        "dunst": "rgb(150 175 215 / .24)",
        "glas": "rgb(255 255 255 / .62)",
        "glasDicht": "rgb(255 255 255 / .80)",
        "glanz": "rgb(255 255 255 / .85)",
        "kanteA": "#FFFFFF",
        "kanteB": "rgb(255 255 255 / .6)",
        "kanteC": "rgb(20 40 80 / .06)",
        "kanteD": "rgb(20 40 80 / .13)",
        "leiste": "rgb(250 252 255 / .72)",
        "leisteAktiv": "rgb(13 21 38 / .07)",
        "linseGrund": "rgb(255 255 255 / .72)",
        "linseLicht": "#FFFFFF",
        "linseRand": "rgb(13 21 38 / .10)",
        "flaecheLeise": "rgb(13 21 38 / .06)",
        "linie": "rgb(13 21 38 / .09)",
        "linieStark": "rgb(13 21 38 / .18)",
        "knopfRand": "rgb(21 34 58 / .34)",
        "text": "#0D1526",
        "text2": "#4A586F",
        "knopfHell": "#15223A",
        "aufKnopfHell": "#FFFFFF",
        "ueberfaellig": "#D9472A",
        "ueberfaelligText": "#B23A1E",
        "bald": "#15223A",
        "spaeter": "#7D8AA0",
        "spaeterFuellung": "rgb(125 138 160 / .14)",
        "erledigt": "#13946B",
        "erledigtText": "#08704F",
        "ringOffen": "#7D8AA0",
        "spur": "rgb(13 21 38 / .06)",
        "passt": "#08704F",
        "aufPasst": "#FFFFFF",
        "schalterAus": "rgb(13 21 38 / .12)",
        "schalterZwei": "#13946B",
        "punktRand": "#F7F9FC",
        "funke": "#12809A",
        "funkeText": "#0F4C5C",
        "funkeKante": "transparent",
        "markierung": "rgb(18 128 154 / .16)",
        "aufMarkierung": "#0D1526",
        "fokus": "#15223A",
        "auswahl": "rgb(18 128 154 / .22)",
        "geistLeib": "#0F4C5C",
        "geistAuge": "#F4F9FB",
        "geistLicht": "#FFFFFF",
        "geistLichtNah": ".95",
        "geistLichtWeit": ".8",
        "auraInnen": "rgb(255 255 255 / .95)",
        "auraAussen": "rgb(255 255 255 / .5)",
        "angeleuchtet": "#15223A",
        "teilchen": "rgb(15 76 92 / .35)",
        "schleier": "rgb(238 242 248 / .72)",
        "lichtkoerperA": "rgb(255 255 255 / .8)",
        "lichtkoerperB": "rgb(217 71 42 / .05)",
        "lichtkoerperD": "rgb(150 175 215 / .22)",
        "tiefe": "0 22px 40px -26px rgb(22 40 80 / .36), 0 2px 6px -3px rgb(22 40 80 / .16)",
        "ruheTiefe": "0 14px 30px -22px rgb(22 40 80 / .26), 0 1px 2px rgb(22 40 80 / .05)"
      }
    },
    "tintenblau": {
      "dunkel": {
        "grundOben": "#131B45",
        "grundMitte": "#0C122F",
        "grundUnten": "#080B1F",
        "dunst": null,
        "glas": "rgb(36 48 104 / .56)",
        "glasDicht": "rgb(30 40 88 / .88)",
        "glanz": "rgb(175 195 255 / .11)",
        "kanteA": "rgb(222 230 255 / .5)",
        "kanteB": "rgb(222 230 255 / .12)",
        "kanteC": "rgb(222 230 255 / .03)",
        "kanteD": "rgb(222 230 255 / .14)",
        "leiste": "rgb(26 36 82 / .62)",
        "leisteAktiv": "rgb(158 180 255 / .16)",
        "linseGrund": "rgb(158 180 255 / .1)",
        "linseLicht": "rgb(222 230 255 / .2)",
        "linseRand": "rgb(222 230 255 / .16)",
        "flaecheLeise": "rgb(158 180 255 / .055)",
        "linie": "rgb(158 180 255 / .14)",
        "linieStark": null,
        "knopfRand": "rgb(158 180 255 / .34)",
        "text": "#EEF1FF",
        "text2": "#A8B2DA",
        "knopfHell": "#EEF1FF",
        "aufKnopfHell": "#0A0F2A",
        "ueberfaellig": "#FF6E4E",
        "ueberfaelligText": "#FF957C",
        "bald": "#9EB4FF",
        "spaeter": "#9EB4FF",
        "spaeterFuellung": "rgb(158 180 255 / .16)",
        "erledigt": "#45E0B0",
        "erledigtText": "#45E0B0",
        "ringOffen": "#8590BC",
        "spur": "rgb(158 180 255 / .13)",
        "passt": "#45E0B0",
        "aufPasst": "#0A0F2A",
        "schalterAus": "rgb(158 180 255 / .2)",
        "schalterZwei": "#9EB4FF",
        "punktRand": null,
        "funke": "#FFC83D",
        "funkeText": "#FFC83D",
        "funkeKante": "transparent",
        "markierung": "#FFC83D",
        "aufMarkierung": "#0A0F2A",
        "fokus": "#FFC83D",
        "auswahl": "#FFC83D",
        "geistLeib": "#F4F6FF",
        "geistAuge": "#0A0F2A",
        "geistLicht": "#9EB4FF",
        "geistLichtNah": ".9",
        "geistLichtWeit": ".5",
        "auraInnen": "rgb(158 180 255 / .5)",
        "auraAussen": "rgb(158 180 255 / .16)",
        "angeleuchtet": "#9EB4FF",
        "teilchen": "rgb(158 180 255 / .9)",
        "schleier": "rgb(4 6 18 / .64)",
        "lichtkoerperA": "rgb(158 180 255 / .2)",
        "lichtkoerperB": "rgb(255 110 78 / .1)",
        "lichtkoerperD": "rgb(120 140 255 / .16)",
        "tiefe": "0 24px 44px -26px rgb(2 3 12 / .9), 0 2px 8px -3px rgb(2 3 12 / .55)",
        "ruheTiefe": "0 18px 34px -26px rgb(2 3 12 / .85)"
      },
      "hell": {
        "grundOben": "#F4F6FD",
        "grundMitte": "#EAEFFA",
        "grundUnten": "#E2E8F6",
        "dunst": null,
        "glas": "rgb(255 255 255 / .68)",
        "glasDicht": "rgb(255 255 255 / .93)",
        "glanz": "rgb(255 255 255 / .8)",
        "kanteA": "#FFFFFF",
        "kanteB": "rgb(255 255 255 / .6)",
        "kanteC": "rgb(16 23 63 / .06)",
        "kanteD": "rgb(16 23 63 / .14)",
        "leiste": "rgb(255 255 255 / .62)",
        "leisteAktiv": "rgb(16 23 63 / .08)",
        "linseGrund": null,
        "linseLicht": null,
        "linseRand": null,
        "flaecheLeise": "rgb(16 23 63 / .04)",
        "linie": "rgb(16 23 63 / .1)",
        "linieStark": null,
        "knopfRand": "rgb(120 150 255 / .34)",
        "text": "#10173F",
        "text2": "#4A5378",
        "knopfHell": "#10173F",
        "aufKnopfHell": "#FFFFFF",
        "ueberfaellig": "#DB4527",
        "ueberfaelligText": "#B8341A",
        "bald": "#3352CC",
        "spaeter": "#3352CC",
        "spaeterFuellung": "rgb(51 82 204 / .1)",
        "erledigt": "#14A273",
        "erledigtText": "#08724F",
        "ringOffen": "#6A739A",
        "spur": "rgb(16 23 63 / .08)",
        "passt": "#08724F",
        "aufPasst": "#FFFFFF",
        "schalterAus": "rgb(120 150 255 / .2)",
        "schalterZwei": "#3352CC",
        "punktRand": null,
        "funke": "#FFC83D",
        "funkeText": "#8A5B00",
        "funkeKante": "#9A6A00",
        "markierung": "#FFC83D",
        "aufMarkierung": "#0A0F2A",
        "fokus": "#1B2768",
        "auswahl": "#FFC83D",
        "geistLeib": "#1B2768",
        "geistAuge": "#F4F6FF",
        "geistLicht": "#96AAF5",
        "geistLichtNah": ".55",
        "geistLichtWeit": ".45",
        "auraInnen": "rgb(255 255 255 / .95)",
        "auraAussen": "rgb(196 208 255 / .55)",
        "angeleuchtet": "#96AAF5",
        "teilchen": "rgb(27 39 104 / .35)",
        "schleier": "rgb(236 240 250 / .72)",
        "lichtkoerperA": "rgb(158 180 255 / .34)",
        "lichtkoerperB": "rgb(255 110 78 / .14)",
        "lichtkoerperD": "rgb(158 180 255 / .26)",
        "tiefe": "0 22px 40px -26px rgb(27 39 104 / .42), 0 2px 6px -3px rgb(27 39 104 / .18)",
        "ruheTiefe": "0 14px 30px -22px rgb(27 39 104 / .3), 0 1px 2px rgb(27 39 104 / .05)"
      }
    }
  },
  "ungeprueft": {
    "tintenblau.dunkel.linseGrund": "in r13-schlicht.html deklariert, auf keiner Seite gerendert (R10 zeigt farbige Kategoriekreise)",
    "tintenblau.dunkel.linseLicht": "wie linseGrund",
    "tintenblau.dunkel.linseRand": "wie linseGrund",
    "nachtblau.dunkel.flaecheLeise": "r13 .pal-r9 --band; in R11 heißt derselbe Wert --knopf-glas",
    "nachtblau.hell.flaecheLeise": "r13 .pal-r9.tag --band; R11 nimmt für „Anders“ rgb(255 255 255 / .7) (--knopf-glas)"
  },
  "offen": {
    "tintenblau.*.linieStark": "R10 kennt keine starke Linie; Vorschlag: knopfRand derselben Palette",
    "tintenblau.hell.linseGrund": "nirgends gebaut; Vorschlag: Werte von nachtblau.hell (weißes Glas), Rand rgb(16 23 63 / .10)",
    "tintenblau.hell.linseLicht": "wie linseGrund",
    "tintenblau.hell.linseRand": "wie linseGrund",
    "tintenblau.*.punktRand": "R10 hat keine Linsen mit Zustandspunkt; Vorschlag: grundMitte der Palette",
    "tintenblau.*.dunst": "R10 hat keinen Dunst; Vorschlag: weglassen",
    "kategoriefarben": "R10 färbt Symbolkreise je Kategorie (--kat-*); R11 und R13 nicht. Nicht übernommen, siehe abweichungen.md"
  },
  "verlaeufe": {
    "grund": {
      "nachtblau": "linear-gradient(180deg, grundOben 0%, grundMitte 42%, grundUnten 100%)",
      "tintenblau": "linear-gradient(180deg, grundOben 0%, grundMitte 34%, grundUnten 72%)"
    },
    "dunst": "radial-gradient(470px 380px at -4% 104%, dunst, transparent 70%) über dem Grund (nur nachtblau, lebhaft)",
    "glasLebhaft": "radial-gradient(130% 90% at 0% 0%, glanz, transparent 52%), glas; dazu 1 px Lichtkante linear-gradient(150deg, kanteA, kanteB 32%, kanteC 62%, kanteD)",
    "glasRuhig": "glas, Rand 1 px linie, Schatten ruheTiefe"
  },
  "schrift": {
    "familien": {
      "titel": "\"Bricolage Grotesque\", \"Avenir Next Condensed\", \"Arial Narrow\", system-ui, sans-serif",
      "text": "\"Inter\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif"
    },
    "ziffern": "tabellarisch auf dem ganzen Bildschirm (font-variant-numeric: tabular-nums)",
    "stufen": {
      "lebhaft": {
        "satzGeist": {
          "familie": "titel",
          "groesse": 21,
          "gewicht": 640,
          "breite": 88,
          "zeilenhoehe": 1.2,
          "laufweite": -0.01,
          "betont": 760
        },
        "kopfZeile": {
          "familie": "titel",
          "groesse": 25,
          "gewicht": 600,
          "breite": 88,
          "zeilenhoehe": 1.15,
          "laufweite": -0.01,
          "betont": 760
        },
        "satzUnterwegs": {
          "familie": "titel",
          "groesse": 18,
          "gewicht": 620,
          "breite": 90,
          "zeilenhoehe": 1.24,
          "laufweite": -0.005,
          "betont": 760
        },
        "satzAkten": {
          "familie": "titel",
          "groesse": 19.5,
          "gewicht": 640,
          "breite": 88,
          "zeilenhoehe": 1.22
        },
        "seitenTitel": {
          "familie": "titel",
          "groesse": 42,
          "gewicht": 740,
          "breite": 80,
          "zeilenhoehe": 1,
          "laufweite": -0.02
        },
        "modulTitel": {
          "familie": "titel",
          "groesse": 24,
          "gewicht": 700,
          "breite": 84,
          "zeilenhoehe": 1.05,
          "laufweite": -0.015
        },
        "abschnittTitel": {
          "familie": "titel",
          "groesse": 23,
          "gewicht": 700,
          "breite": 86,
          "zeilenhoehe": 1.05,
          "laufweite": -0.015
        },
        "kachelZahl": {
          "familie": "titel",
          "groesse": 50,
          "gewicht": 720,
          "breite": 78,
          "zeilenhoehe": 0.86,
          "laufweite": -0.03
        },
        "summe": {
          "familie": "titel",
          "groesse": 24,
          "gewicht": 700,
          "breite": 80,
          "zeilenhoehe": 1,
          "laufweite": -0.02
        },
        "beitragAkte": {
          "familie": "titel",
          "groesse": 34,
          "gewicht": 720,
          "breite": 78,
          "zeilenhoehe": 0.9,
          "laufweite": -0.025
        },
        "betragZeile": {
          "familie": "titel",
          "groesse": 24,
          "gewicht": 720,
          "breite": 80,
          "zeilenhoehe": 1
        },
        "betragFrist": {
          "familie": "titel",
          "groesse": 19,
          "gewicht": 700,
          "breite": 82,
          "zeilenhoehe": 1,
          "laufweite": -0.015
        },
        "fristVorschlag": {
          "familie": "titel",
          "groesse": 30,
          "gewicht": 720,
          "breite": 80,
          "zeilenhoehe": 1,
          "laufweite": -0.02
        },
        "titelKarte": {
          "familie": "titel",
          "groesse": 21,
          "gewicht": 700,
          "breite": 86,
          "zeilenhoehe": 1.1,
          "laufweite": -0.01
        },
        "titelVorschlag": {
          "familie": "titel",
          "groesse": 20,
          "gewicht": 700,
          "breite": 86,
          "zeilenhoehe": 1.15,
          "laufweite": -0.01
        },
        "anzahl": {
          "familie": "titel",
          "groesse": 20,
          "gewicht": 600,
          "breite": 88
        },
        "zeilenTitel": {
          "familie": "text",
          "groesse": 15.5,
          "gewicht": 620,
          "zeilenhoehe": 1.25
        },
        "knopf": {
          "familie": "text",
          "groesse": 16,
          "gewicht": 650
        },
        "knopfKlein": {
          "familie": "text",
          "groesse": 15,
          "gewicht": 650
        },
        "lesetext": {
          "familie": "text",
          "groesse": 15,
          "gewicht": 400,
          "zeilenhoehe": 1.55
        },
        "nebentext": {
          "familie": "text",
          "groesse": 14,
          "gewicht": 400,
          "zeilenhoehe": 1.3
        },
        "untertitel": {
          "familie": "text",
          "groesse": 13.5,
          "gewicht": 500,
          "zeilenhoehe": 1.2
        },
        "zustand": {
          "familie": "text",
          "groesse": 12.5,
          "gewicht": 620,
          "zeilenhoehe": 1.2
        },
        "legende": {
          "familie": "text",
          "groesse": 12.5,
          "gewicht": 550
        },
        "achse": {
          "familie": "text",
          "groesse": 11.5,
          "gewicht": 550,
          "zeilenhoehe": 1.391
        },
        "reiter": {
          "familie": "text",
          "groesse": 11,
          "gewicht": 600,
          "aktiv": 750
        },
        "pille": {
          "familie": "text",
          "groesse": 11.5,
          "gewicht": 750
        }
      },
      "ruhig": {
        "satzGeist": {
          "familie": "titel",
          "groesse": 20,
          "gewicht": 600,
          "breite": 90,
          "zeilenhoehe": 1.3,
          "laufweite": -0.006,
          "betont": 720
        },
        "kopfZeile": {
          "familie": "titel",
          "groesse": 25,
          "gewicht": 620,
          "breite": 88,
          "zeilenhoehe": 1.12,
          "laufweite": -0.01,
          "betont": 700
        },
        "satzUnterwegs": {
          "familie": "titel",
          "groesse": 17.5,
          "gewicht": 600,
          "breite": 90,
          "zeilenhoehe": 1.3,
          "laufweite": -0.004,
          "betont": 720
        },
        "satzRand": {
          "familie": "titel",
          "groesse": 16.5,
          "gewicht": 600,
          "breite": 90,
          "zeilenhoehe": 1.3
        },
        "satzAkten": {
          "familie": "titel",
          "groesse": 17.5,
          "gewicht": 600,
          "breite": 90,
          "zeilenhoehe": 1.25
        },
        "seitenTitel": {
          "familie": "titel",
          "groesse": 40,
          "gewicht": 720,
          "breite": 80,
          "zeilenhoehe": 1,
          "laufweite": -0.02
        },
        "modulTitel": {
          "familie": "titel",
          "groesse": 23,
          "gewicht": 680,
          "breite": 84,
          "zeilenhoehe": 1.05,
          "laufweite": -0.012
        },
        "abschnittTitel": {
          "familie": "titel",
          "groesse": 22,
          "gewicht": 680,
          "breite": 86,
          "zeilenhoehe": 1.1,
          "laufweite": -0.01
        },
        "offenZahl": {
          "familie": "titel",
          "groesse": 24,
          "gewicht": 680,
          "breite": 80,
          "zeilenhoehe": 0.9,
          "laufweite": -0.02
        },
        "summe": {
          "familie": "titel",
          "groesse": 26,
          "gewicht": 680,
          "breite": 80,
          "zeilenhoehe": 1,
          "laufweite": -0.018
        },
        "beitragAkte": {
          "familie": "titel",
          "groesse": 34,
          "gewicht": 700,
          "breite": 78,
          "zeilenhoehe": 0.9,
          "laufweite": -0.024
        },
        "betragZeile": {
          "familie": "titel",
          "groesse": 18.5,
          "gewicht": 680,
          "breite": 82,
          "zeilenhoehe": 1,
          "laufweite": -0.012
        },
        "betragFrist": {
          "familie": "titel",
          "groesse": 18.5,
          "gewicht": 680,
          "breite": 82,
          "zeilenhoehe": 1,
          "laufweite": -0.012
        },
        "titelKarte": {
          "familie": "titel",
          "groesse": 20,
          "gewicht": 680,
          "breite": 86,
          "zeilenhoehe": 1.1,
          "laufweite": -0.008
        },
        "titelVorschlag": {
          "familie": "titel",
          "groesse": 19,
          "gewicht": 680,
          "breite": 86,
          "zeilenhoehe": 1.15,
          "laufweite": -0.008
        },
        "anzahl": {
          "familie": "titel",
          "groesse": 19,
          "gewicht": 560,
          "breite": 88
        },
        "zeilenTitel": {
          "familie": "text",
          "groesse": 15.5,
          "gewicht": 600,
          "zeilenhoehe": 1.25
        },
        "knopf": {
          "familie": "text",
          "groesse": 16,
          "gewicht": 640
        },
        "knopfKlein": {
          "familie": "text",
          "groesse": 15,
          "gewicht": 620
        },
        "lesetext": {
          "familie": "text",
          "groesse": 15,
          "gewicht": 400,
          "zeilenhoehe": 1.55
        },
        "nebentext": {
          "familie": "text",
          "groesse": 13.5,
          "gewicht": 400,
          "zeilenhoehe": 1.3
        },
        "untertitel": {
          "familie": "text",
          "groesse": 13.5,
          "gewicht": 500,
          "zeilenhoehe": 1.2
        },
        "offenName": {
          "familie": "text",
          "groesse": 12.5,
          "gewicht": 550,
          "zeilenhoehe": 1.1
        },
        "zustand": {
          "familie": "text",
          "groesse": 12.5,
          "gewicht": 600,
          "zeilenhoehe": 1.2
        },
        "legende": {
          "familie": "text",
          "groesse": 12.5,
          "gewicht": 550
        },
        "achse": {
          "familie": "text",
          "groesse": 11.5,
          "gewicht": 550,
          "zeilenhoehe": 1.391
        },
        "reiter": {
          "familie": "text",
          "groesse": 11,
          "gewicht": 600,
          "aktiv": 700
        },
        "pille": {
          "familie": "text",
          "groesse": 11.5,
          "gewicht": 720
        }
      }
    },
    "einheiten": "groesse in px (Web) = pt (iOS) = sp (Android); breite in % (font-stretch, Achse wdth); laufweite in em"
  },
  "abstaende": {
    "seitenrand": 16,
    "inhaltOben": 58,
    "inhaltUntenLebhaft": 142,
    "inhaltUntenRuhig": 150,
    "kopfInnen": "6 16 0",
    "geistSzeneOben": 6,
    "zumOffenBlock": 14,
    "zuDenFristen": 20,
    "zwischenAbschnitten": 28,
    "lebhaft": {
      "zuDenKacheln": 12,
      "kachelLuecke": 10,
      "zuDenFristen": 24,
      "zwischenAbschnitten": 28
    },
    "abschnittKopfUnten": 10,
    "modulInnen": "18 16 0 18",
    "vorschlagInnen": 18,
    "zeileInnenLebhaft": "14 16",
    "zeileInnenRuhig": "12 16 12 14",
    "aktenLuecke": {
      "lebhaft": 10,
      "ruhig": 12
    },
    "blaseInnen": "16 16 14 18",
    "unterwegsInnen": "14 12 10 16",
    "tabLeiste": {
      "seitlich": 14,
      "unten": 24,
      "innen": 5
    }
  },
  "radien": {
    "glas": 26,
    "modul": 28,
    "kachel": 24,
    "zeile": {
      "lebhaft": 24,
      "ruhig": 22
    },
    "offenBlock": 24,
    "offenZelle": 20,
    "kopfblase": {
      "lebhaft": "26 26 26 8",
      "ruhig": "24 24 24 8",
      "kleinRuhig": "22 22 22 8"
    },
    "blaseUnterwegs": "24 24 8 24",
    "blaseRand": "8 20 20 20",
    "hinweis": 18,
    "knopf": 25,
    "knopfKlein": 22,
    "tabLeiste": 35,
    "reiterLicht": 30,
    "schalterZeile": 18,
    "schalterBahn": 16,
    "fakt": 16,
    "status": 12,
    "abzeichen": 10,
    "saeule": 11,
    "segment": 10,
    "markierungLebhaft": 5,
    "kreis": "50 %",
    "pille": 999,
    "regel": "Die Blase hat genau eine kleine Ecke von 8 px; sie zeigt auf die Figur des Geists."
  },
  "masse": {
    "geist": {
      "lebhaft": 124,
      "ruhig": 96,
      "flieger": {
        "lebhaft": 132,
        "ruhig": 104
      },
      "platz": {
        "lebhaft": "132 x 172",
        "ruhig": "108 x 136"
      },
      "aufModul": {
        "lebhaft": 0.55,
        "ruhig": 0.58
      },
      "aufZeile": 0.5,
      "aufKachel": 0.42,
      "aktenPlatz": {
        "lebhaft": 0.5,
        "ruhig": 0.66
      },
      "aktenSzene": {
        "lebhaft": "76 x 92 (R11 ab 17.10. 13:05)",
        "ruhig": "80 x 96"
      }
    },
    "aura": {
      "lebhaft": 360,
      "ruhig": 250
    },
    "farbschein": {
      "lebhaft": 270,
      "ruhig": 190
    },
    "welle": 166,
    "treffer": 44,
    "knopf": 50,
    "knopfKlein": 44,
    "linse": 44,
    "kuerzel": 44,
    "haken": 44,
    "hakenKreis": 26,
    "tabLeiste": 70,
    "reiter": 60,
    "saeule": "30 x 104",
    "diagramm": 194,
    "zeileFrist": 66,
    "zeileListe": {
      "lebhaft": 72,
      "ruhig": 70
    },
    "schalter": {
      "bahn": "52 x 32",
      "knopf": 26,
      "weg": 20
    },
    "blaseUnterwegs": {
      "lebhaft": 254,
      "ruhig": 252
    },
    "randBlaseMax": 290,
    "hinweisMax": 320
  },
  "unschaerfe": {
    "regel": "Echte Unschärfe nur, wo etwas darunter liegt: Tab-Leiste, schwebende Blase, Randgeist, Hinweis (lebhaft)",
    "tabLeiste": {
      "lebhaft": "blur(24px) saturate(170%)",
      "ruhig": "blur(24px) saturate(160%)"
    },
    "blaseUnterwegs": {
      "lebhaft": "blur(18px) saturate(150%)",
      "ruhig": "blur(16px) saturate(140%)"
    },
    "blaseRand": "blur(18px) saturate(140%)",
    "hinweis": {
      "lebhaft": "blur(18px)",
      "ruhig": "keine"
    },
    "weniger": "prefers-reduced-transparency: keine Unschärfe, Fläche glasDicht"
  },
  "kurven": {
    "expo": "cubic-bezier(0.16, 1, 0.3, 1)",
    "feder": "cubic-bezier(0.34, 1.5, 0.64, 1)",
    "federLinear": "linear(0, 0.16 5%, 0.5 12%, 0.83 20%, 1.04 29%, 1.08 35%, 1.06 41%, 1.02 50%, 0.995 61%, 0.993 70%, 1)",
    "fest": "linear(0, 0.12 7%, 0.346 14%, 0.565 21%, 0.737 29%, 0.856 36%, 0.93 43%, 0.972 50%, 0.994 57%, 1.003 64%, 1.006 71%, 1.006 79%, 1.005 86%, 1.003 93%, 1)",
    "sanft": "cubic-bezier(0.45, 0, 0.55, 1)",
    "mit": "cubic-bezier(0.3, 0.8, 0.3, 1)",
    "landen": "cubic-bezier(0.3, 0.7, 0.4, 1)",
    "vorhang": "cubic-bezier(0.55, 0, 0.25, 1)",
    "weg": "cubic-bezier(0.4, 0, 1, 1)",
    "flugbahn": "kubisch ein und aus je Strecke (t < .5 ? 4t³ : 1 - (-2t + 2)³ / 2), Zeitachse linear",
    "verwendung": {
      "lebhaft": "expo für Licht und Blenden, feder für Knöpfe, Blasen, Pillen, Schalter",
      "ruhig": "nur expo, sanft und landen; keine Feder mit Überschwingen"
    }
  },
  "dauern": {
    "leben": {
      "atmen": {
        "lebhaft": 6000,
        "ruhig": 6800
      },
      "blinzeln": 6600,
      "blick": 9000,
      "funkeln": {
        "lebhaft": 3200,
        "ruhig": 4400,
        "glypheLebhaft": 3800
      },
      "schweben": {
        "lebhaft": {
          "dauer": 4200,
          "hub": 7,
          "neigung": 1.5
        },
        "ruhig": {
          "ueberall": {
            "dauer": 5000,
            "hub": 5,
            "neigung": 1.2
          },
          "erklaeren": {
            "dauer": 5000,
            "hub": 3,
            "neigung": 0.8
          },
          "keine": {
            "dauer": 5000,
            "hub": 2,
            "neigung": 0
          }
        }
      },
      "teilchen": "6400 bis 9000 (nur lebhaft, Überall)"
    },
    "auftritt": {
      "lebhaft": {
        "vorhang": 1600,
        "erscheinen": 1100,
        "aura": 1200,
        "kopf": 700,
        "kachel": 560,
        "staffel": 800,
        "saeulen": 900,
        "punkte": 600,
        "leiste": 900,
        "rundflugAb": 1150,
        "blase": 720
      },
      "lebhaftErklaeren": {
        "kopf": 600,
        "erscheinen": 1000,
        "aura": 1100,
        "staffel": 800,
        "saeulen": 900,
        "leiste": 800,
        "blase": 720
      },
      "lebhaftKeine": {
        "einblenden": 520
      },
      "ruhig": {
        "erscheinen": 1000,
        "aura": 1400,
        "kopf": 600,
        "rede": 700,
        "rest": 760,
        "leiste": 700,
        "fertig": 1600
      },
      "ruhigErklaeren": {
        "erscheinen": 700,
        "aura": 800,
        "rede": 560,
        "rest": 520,
        "fertig": 1000
      },
      "ruhigKeine": {
        "einblenden": 420,
        "fertig": 520
      }
    },
    "flug": {
      "lebhaft": {
        "strecke": "min(950, max(300, 260 + 0,6 x Weg in px)) ms",
        "bogen": "min(70, 0,22 x Weg) px",
        "neigung": "höchstens 12 Grad",
        "lichtspur": 900,
        "mitgleiten": 640
      },
      "ruhig": {
        "strecke": "min(1100, max(460, 340 + 0,5 x Weg in px)) ms",
        "bogen": "min(44, 0,15 x Weg) px",
        "neigung": "höchstens 8 Grad",
        "lichtspur": 0,
        "mitgleiten": 560
      }
    },
    "gesten": {
      "lebhaft": {
        "hopsen": 720,
        "landen": 520,
        "funke": 900,
        "strahlen": 700,
        "welle": 1000,
        "farbschein": 1300,
        "leuchtenLeise": 1400,
        "umsetzenAus": 180,
        "umsetzenEin": 340
      },
      "ruhig": {
        "hopsen": 680,
        "landen": 460,
        "nicken": 680,
        "blick": 1300,
        "funkeln": 760,
        "licht": 1300
      }
    },
    "antwort": {
      "lebhaft": {
        "aufleuchten": 1500,
        "anstossen": 560,
        "zaehlen": 760,
        "nachziehen": 520,
        "hervor": 900,
        "scheinwerfer": 500
      },
      "ruhig": {
        "fristLicht": 1250,
        "kreis": 520,
        "saeuleLicht": 1100,
        "punkt": 700,
        "karteLicht": 1150,
        "markieren": 1400,
        "zahlTausch": 380
      }
    },
    "zahlenRollen": {
      "raus": 420,
      "rein": 640,
      "versatz": {
        "lebhaft": "40 %",
        "ruhig": "45 %"
      }
    },
    "blasen": {
      "lebhaft": {
        "unterwegsEin": 640,
        "unterwegsWechsel": 420,
        "unterwegsAus": 170,
        "satzWechsel": 620,
        "hinweisSichtbar": 2800
      },
      "ruhig": {
        "unterwegsEin": 520,
        "unterwegsWechsel": 360,
        "unterwegsAus": 170,
        "satzWechsel": 560,
        "randgeistSichtbar": 4000,
        "aktenBemerkung": 3800,
        "hinweisSichtbar": 2800
      }
    },
    "wechsel": {
      "bildschirm": {
        "lebhaft": {
          "raus": 240,
          "rein": 460,
          "weg": 24
        },
        "ruhig": {
          "raus": 220,
          "rein": 440,
          "weg": 16
        }
      },
      "lichtkreis": {
        "lebhaft": 780,
        "ruhig": 820
      },
      "sortieren": {
        "lebhaft": 640,
        "ruhig": 600
      },
      "aufklappen": {
        "lebhaft": 520,
        "ruhig": 460
      },
      "mehrZeilen": {
        "lebhaft": 460,
        "ruhig": 420
      }
    },
    "druck": {
      "lebhaft": "scale(.95) bis scale(.97), 450 bis 500 ms feder",
      "ruhig": "scale(.96), 400 ms expo"
    },
    "wenigerBewegung": "alle Dauern 0; Endzustände sofort; Bestand der App: Blenden höchstens 120 ms (PGTokens Motion.reduced, tokens.css --dur-reduced-fade)"
  }
}
